// /var/www/website2024/dev.afaa.website/s-293-spatime-dev/src/components/register.js

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
//import { useAuth } from '../components/AuthContext';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import '../styles/scss/PaymentForm.scss';

const RegisterForm = ({ hidePasswordFields, autoGeneratedPassword, onSuccess, initialFormData  }) => {
  //const { setIsLoggedIn } = useAuth();
  const navigate = useNavigate();


  const [formData, setFormData] = useState({
    first_name: initialFormData?.first_name || '',
    sur_name: initialFormData?.sur_name || '',
    telephone: initialFormData?.telephone || '',
    email: initialFormData?.email || '',
    password: initialFormData?.password || autoGeneratedPassword,
    confirmPassword: initialFormData?.password || autoGeneratedPassword,
    ip: '',
    date: '',
    time: ''
  });

  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false); // For spinner control  

  // Use effect to set the auto-generated password and confirm password
  useEffect(() => {
    if (hidePasswordFields) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        password: autoGeneratedPassword,
        confirmPassword: autoGeneratedPassword,
      }));
    }
  }, [hidePasswordFields, autoGeneratedPassword]);


  // Handle form field changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  // Fetch the user's IP address
  const fetchUserIp = async () => {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error('Error fetching IP:', error);
    }
  };


  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      alert("Passwords don't match.");
      return;
    }

    // Format the date and time
    const currentDate = new Date();
    const date = currentDate.toISOString().split('T')[0]; // "2023-12-09"
    const time = currentDate.toTimeString().split(' ')[0]; // "22:38:28"

    // Get the user's IP address
    const userIp = await fetchUserIp();
    if (userIp) {
      formData.ip = userIp;
    }

    formData.date = date;
    formData.time = time;

    // แสดง date, time และ ip ก่อนส่ง
    console.log(`Date: ${date}, Time: ${time}, IP: ${userIp}`);
    console.log(JSON.stringify(formData));


    try {
      const response = await fetch('https://py.testproject.work/register/api/insert', {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log(result);

      // Clear the form inputs
      setFormData({
        first_name: '',
        sur_name: '',
        telephone: '',
        email: '',
        password: '',
        confirmPassword: '',
        ip: '',
        date: '',
        time: ''
      });



      //alert("Registration successful!");  

      const handleRegistrationSuccess = () => {
        // Display the modal with registration success message
        setModalMessage('Registration successful! Logging you in...');
        setShowModal(true);
        setIsLoading(true); // Begin loading state

        // Proceed with autoLogin or any other post-registration logic here...
        // Example autoLogin call
        autoLogin(formData.email, formData.password);

        if (onSuccess) {
          onSuccess(); // This will trigger the callback passed to RegisterForm
        }

      };

      // Add this function within the RegisterForm component
      const autoLogin = async (email, password) => {
        try {
          const response = await fetch('https://py.testproject.work/login/api/check', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ email, password })
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const loginResult = await response.json();
          setIsLoading(false);

          if (loginResult.message === 'OK') {
            localStorage.setItem('token', loginResult.token);
            localStorage.setItem('userData', JSON.stringify(loginResult.user));

            // Set modal message and show modal on successful login
            setModalMessage('Login Successful. Welcome!');
            setShowModal(true);

            // Optionally, hide the modal after a delay and navigate or reload
            // Note: This step can be adjusted based on when you want to navigate or reload the page
            setTimeout(() => {
              if (window.location.pathname === '/register') {
                navigate('/profile', { replace: true });
                window.location.reload();
              } else {
                window.location.reload();
              }
            }, 3000); // Adjust timing as needed
          } else {
            // Use modal to display error message
            setModalMessage(loginResult.message || 'An unexpected error occurred.');
            setShowModal(true);
          }

          // Call handleRegistrationSuccess instead of showing an alert
          handleRegistrationSuccess();
        } catch (error) {
          console.error('Error during auto login:', error);
          setModalMessage('An error occurred during login. Please try again.');
          setShowModal(true);
        }
      };


      // Then, within the handleSubmit function, call autoLogin after the registration success alert:
      // After `alert("Registration successful!");`
      autoLogin(formData.email, formData.password);

    } catch (error) {
      console.error('Error during registration:', error);
      // Specific message for status 400
      if (error.message.includes('400')) {
        setModalMessage('Ladresse e-mail et/ou le numéro de téléphone sont déjà utilisés. Veuillez réessayer avec des informations d identification différentes.');
      } else {
        setModalMessage('An unexpected error occurred. Please try again later.');
        setShowModal(true);
      }
      setShowModal(true);
    }
  };

  return (
    <>
     <div className="card shadow-lg p-4 mb-5 bg-white rounded">
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="first_name" className="form-label">Prénom</label>
          <input type="text" className="form-control" id="first_name" required onChange={handleChange} value={formData.first_name} />
        </div>
        <div className="mb-3">
          <label htmlFor="sur_name" className="form-label">Nom de famille</label>
          <input type="text" className="form-control" id="sur_name" required onChange={handleChange} value={formData.sur_name} />
        </div>
        <div className="mb-3">
          <label htmlFor="telephone" className="form-label">Numéro de téléphone</label>
          <input type="tel" className="form-control" id="telephone" onChange={handleChange} value={formData.telephone} />
        </div>
        <div className="mb-3">
          <label htmlFor="email" className="form-label">Email</label>
          <input type="email" className="form-control" id="email" required onChange={handleChange} value={formData.email} />
        </div>

        {!hidePasswordFields && (
          <div className="mb-3">
            <label htmlFor="password" className="form-label">Password</label>
            <input
              type="password"
              className="form-control"
              id="password"
              required
              autoComplete="new-password"
              onChange={handleChange}
              value={formData.password}
            />
          </div>
         )} 

        {!hidePasswordFields && ( 
          <div className="mb-3">
            <label htmlFor="confirmPassword" className="form-label">Confirmer Password</label>
            <input type="password" className="form-control" id="confirmPassword" required autoComplete="new-password" onChange={handleChange} value={formData.confirmPassword} />
          </div>
         )} 

        <button type="submit" className="btn custom-button">S'inscrire</button>
      </form>


      <Modal show={showModal} onHide={() => { }} backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title>Notification</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalMessage}</Modal.Body>
        <Modal.Footer>
          <Button className='custom-button' variant="primary" onClick={() => setShowModal(false)} disabled={isLoading}>
            {isLoading ? (
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
            ) : 'Proceed'}
          </Button>
        </Modal.Footer>
      </Modal>
      </div>
    </>


  );
};

export default RegisterForm;
